import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledAppsHeaderWrap, StyledAppsTitleIcon, StyledAppsTitleText, StyledAppsTitleWrap } from "./styles";

const FindAppsHeader = () => {
    return (
        <StyledAppsHeaderWrap data-automation="si.find-apps.page-header">
            <StyledAppsTitleWrap>
                <StyledAppsTitleIcon
                    iconName="phrases"
                    size="sm"
                />

                <I18n
                    element={StyledAppsTitleText}
                    translatable={{
                        key: "si.find_apps.title",
                    }}
                />
            </StyledAppsTitleWrap>
        </StyledAppsHeaderWrap>
    );
};

export default FindAppsHeader;
